import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { ProductService } from '../../../service/product.service';
import { Shop } from '../../../../shop/types/shop.type';
import { UserService } from '../../../../user/services/user.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ShopService } from '../../../../shop/service/shop.service';
import { ButtonModule } from 'primeng/button';
@Component({
  selector: 'app-edit-attribute-media-seller',
  templateUrl: './edit-attribute-media-seller.component.html',
  standalone: true,
  imports: [FileUploadModule, TranslateModule, ProgressSpinnerModule, ButtonModule],
  styleUrls: ['./edit-attribute-media-seller.component.scss']
})
export class EditAttributeMediaSellerComponent implements OnInit {
  uploadedFiles: any[] = [];
  selectedValue = { attributeCode: '', value: null, codeValue: null, referenced: false, source: '' };
  @ViewChild('fileUpload') fileUploadRef: any;
  attribute;
  currentProduct;
  shop: Shop;
  showSpinner = false;
  constructor(public ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private readonly userService: UserService,
      private readonly shopService: ShopService,
      private readonly productService: ProductService) { }

  ngOnInit() {
    this.attribute = this.config?.data['attribute'];
    this.shop = this.shopService.getSelectedShop();
    this.currentProduct = this.config?.data['currentProduct'];
  }
  onUpload(event: any) {
    this.uploadFile(event);
  }

  uploadFile(event: any) {
    this.uploadedFiles = event.files
    this.fileUploadRef.clear(); // 
    const data = this.prepareMediaUpdateData();
    const formData = new FormData();
    formData.append('image', this.uploadedFiles[0], this.uploadedFiles[0].name);
    formData.append('productDetails', new Blob([JSON.stringify(data)], {
      type: 'application/json'
    }));
    this.showSpinner = true;
    this.productService.updateSellerMediaProduct(formData).subscribe({
      next: (message) => {
        this.showSpinner = false;
        this.closeDialog('success');
      },
      error: () => {
        this.showSpinner = false;
        this.closeDialog('error');
      }
    });
  }
  onFileSelect(event: any) {
  }
  closeDialog(msg = null): void {
    this.ref.close(msg);
  }

  deleteMedia() {
    const data = this.prepareMediaUpdateData();

    const formData = new FormData();
    formData.append('image', null);
    formData.append('productDetails', new Blob([JSON.stringify(data)], {
      type: 'application/json'
    }));
    this.showSpinner = true;
    this.productService.updateSellerMediaProduct(formData).subscribe({
      next: (message) => {
        this.showSpinner = false;
        this.closeDialog('success');
      },
      error: () => {
        this.showSpinner = false;
        this.closeDialog('error');
      }
    });
  }

  private prepareMediaUpdateData(): any {
    let value = this.selectedValue?.['value'] ?? null;
    let code = null;
    return {
      productId: this.currentProduct.productId,
      shopCode: this.shop.shopCode,
      shopName: this.shop.shopName,
      eans: this.currentProduct.ean,
      sku: this.currentProduct.sku,
      user: this.userService.getUser().email,
      attributesModifications: [{
        localized: this.attribute.localized ,
        project: this.attribute.locale,
        attributeCode: this.attribute.attributeCode,
        attributeValue: value,
        attributeCodeValue: code
      }],
      categoryBreadCrumb: this.currentProduct.category.categoryBreadCrumb,
      isMedia: this.attribute.attributeType === 'MEDIA'
    }
  }
}
